import {PER_PAGE_LIMIT} from "../constants";

const initialState = {
    loading: true,
    currentPage: 0,
    sortData: null,
    wordsData: null,
    searchValue: '',
    currentData: null,
    bottomBarText: null,
    formViewerData: null,
    currentFormData: null,
    adminSummaryData: null,
    currentFormIndex: null,
    formResponsesData: null,
    selectedFormIdsArray: [],
    isHeaderCheckBoxChecked: false,
    totalDataCount: PER_PAGE_LIMIT
}

export const ADMIN_DATA_ACTION_TYPE = {
    SET_LOADING: 'SET_LOADING',
    SET_SORT_DATA: 'SET_SORT_DATA',
    SET_WORDS_DATA: 'SET_WORDS_DATA',
    SET_CURRENT_DATA: 'SET_CURRENT_DATA',
    SET_CURRENT_PAGE: 'SET_CURRENT_PAGE',
    SET_SEARCH_VALUE: 'SET_SEARCH_VALUE',
    SET_BOTTOM_BAR_TEXT: 'SET_BOTTOM_BAR_TEXT',
    SET_TOTAL_DATA_COUNT: 'SET_TOTAL_DATA_COUNT',
    SET_FORM_VIEWER_DATA: 'SET_FORM_VIEWER_DATA',
    SET_CURRENT_FORM_DATA: 'SET_CURRENT_FORM_DATA',
    SET_CURRENT_FORM_INDEX: 'SET_CURRENT_FORM_INDEX',
    SET_ADMIN_SUMMARY_DATA: 'SET_ADMIN_SUMMARY_DATA',
    SET_FORM_RESPONSES_DATA: 'SET_FORM_RESPONSES_DATA',
    SET_SELECTED_FORM_IDS_ARRAY: 'SET_SELECTED_FORM_IDS_ARRAY',
    SET_HEADER_CHECKBOX_CHECKED: 'SET_HEADER_CHECKBOX_CHECKED'
}

const adminDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case (ADMIN_DATA_ACTION_TYPE.SET_TOTAL_DATA_COUNT):
            return {
                ...state,
                totalDataCount: action.payload
            }
        case (ADMIN_DATA_ACTION_TYPE.SET_SORT_DATA):
            return {
                ...state,
                sortData: action.payload
            }
        case (ADMIN_DATA_ACTION_TYPE.SET_SEARCH_VALUE):
            return {
                ...state,
                searchValue: action.payload
            }
        case (ADMIN_DATA_ACTION_TYPE.SET_FORM_RESPONSES_DATA):
            return {
                ...state,
                formResponsesData: action.payload
            }
        case (ADMIN_DATA_ACTION_TYPE.SET_ADMIN_SUMMARY_DATA):
            return {
                ...state,
                adminSummaryData: action.payload
            }
        case (ADMIN_DATA_ACTION_TYPE.SET_BOTTOM_BAR_TEXT):
            return {
                ...state,
                bottomBarText: action.payload
            }
        case (ADMIN_DATA_ACTION_TYPE.SET_CURRENT_PAGE):
            return {
                ...state,
                currentPage: action.payload
            }
        case (ADMIN_DATA_ACTION_TYPE.SET_HEADER_CHECKBOX_CHECKED):
            return {
                ...state,
                isHeaderCheckBoxChecked: action.payload
            }
        case (ADMIN_DATA_ACTION_TYPE.SET_SELECTED_FORM_IDS_ARRAY):
            return {
                ...state,
                selectedFormIdsArray: action.payload
            }
        case (ADMIN_DATA_ACTION_TYPE.SET_CURRENT_DATA):
            return {
                ...state,
                currentData: action.payload
            }
        case (ADMIN_DATA_ACTION_TYPE.SET_WORDS_DATA):
            return {
                ...state,
                wordsData: action.payload
            }
        case (ADMIN_DATA_ACTION_TYPE.SET_LOADING):
            return {
                ...state,
                loading: action.payload
            }
        case (ADMIN_DATA_ACTION_TYPE.SET_CURRENT_FORM_INDEX):
            return {
                ...state,
                currentFormIndex: action.payload
            }
        case (ADMIN_DATA_ACTION_TYPE.SET_CURRENT_FORM_DATA):
            return {
                ...state,
                currentFormData: action.payload
            }
        case (ADMIN_DATA_ACTION_TYPE.SET_FORM_VIEWER_DATA):
            return {
                ...state,
                formViewerData: action.payload
            }
        default:
            return state
    }
}

export default adminDataReducer